const uuidv4 = require('uuid/v4')

const pkg = require('../package.json')

const pkgVersion = `v${pkg.version}`

class Event {

    constructor (props) {
        this.id = props.id
        if (!this.id) {
            this.id = uuidv4()
        }
        
        this.type = Event.TYPE

        this.action = props.action

        this.ip = props.ip

        this.geoipCityName = props.geoipCityName
        this.geoipCountryCode = props.geoipCountryCode
        this.geoipCountryName = props.geoipCountryName
        this.geoipLocation = props.geoipLocation
        this.geoipLocationAccuracyRadius = props.geoipLocationAccuracyRadius

        this.osType = props.osType
        this.osVendor = props.osVendor
        this.osPlatform = props.osPlatform
        this.osPlatformVersion = props.osPlatformVersion
        this.osFamily = props.osFamily
        this.osName = props.osName
        this.osVersion = props.osVersion
        
        this.userAgent = props.userAgent
        this.userLanguage = props.userLanguage
        this.userLocale = props.userLocale
        this.userTimezone = props.userTimezone
        
        this.releaseStage = props.releaseStage
        this.releaseVersion = props.releaseVersion
        this.releaseBuild = props.releaseBuild

        this.timestamp = props.timestamp
        if (!this.timestamp) {
            this.timestamp = (new Date()).toISOString()
        }

        this.telemetryVersion = pkgVersion
    }

    serialise () {
        return JSON.stringify(this)
    }
}

Event.TYPE = 'event'

module.exports = Event
